import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { showToaster } from 'nallian-shared-ui/lib/lib/showToaster';
import { FormUi, Flex, Button, Grid, Field } from 'nallian-shared-ui/lib/components';
import { FileFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import apiRoutes from '../../../../app/api/routes';

const LegalDocsForm = ({
  handleSubmit,
  handleRefetch,
  latestRevision,
  communityId,
  legalDocuments,
}) => {
  const { t } = useTranslation();
  const [uploading, setUploading] = useState(false);

  const onSubmitForm = useCallback(
    async values => {
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append('file', values.terms);
        formData.append('typeId', 2); // fixed communityTermsAndConditions
        formData.append('title', `Community legal documents`);
        formData.append('referenceId', communityId);
        formData.append('revision', latestRevision + 1);

        const execute = legalDocuments?.length ? axios.put : axios.post;
        const apiPath = legalDocuments?.length
          ? apiRoutes.legalDocuments(get(legalDocuments, '[0].id'))
          : apiRoutes.legalDocuments();

        const { data } = await execute(apiPath, formData, {
          headers: { 'content-type': undefined },
        });

        if (data) {
          setUploading(false);
          handleRefetch();
          showToaster('success', t('documentUploaded'));
        }
      } catch (err) {
        showToaster('error', t('documentUploadFailed'));
        setUploading(false);
      }
      return true;
    },
    [legalDocuments, handleRefetch, latestRevision, communityId, t]
  );

  return (
    <Flex fluid>
      <FormUi fluid onSubmit={handleSubmit(onSubmitForm)}>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Field
              fluid
              label={t('uploadNewGeneralTermsAndConditions')}
              name="terms"
              valueComponent={FileFieldValueComponent}
              disabled={false}
            />
          </Grid.Column>
        </Grid>
        <Flex justifyContent="flex-end" margin="1rem 0 0">
          <Button
            btnprimary
            onClick={handleSubmit(onSubmitForm)}
            disabled={uploading}
            loading={uploading}
            icon="save"
            content={t('save')}
          />
        </Flex>
      </FormUi>
    </Flex>
  );
};

LegalDocsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  latestRevision: PropTypes.number.isRequired,
  communityId: PropTypes.string.isRequired,
  handleRefetch: PropTypes.func.isRequired,
  legalDocuments: PropTypes.array,
};

LegalDocsForm.defaultProps = { legalDocuments: [] };

export default reduxForm({
  validate: () => {},
  form: 'legalDoc',
  enableReinitialize: true,
})(LegalDocsForm);
